export const OUTBOUND_FAX_GCS_PREFIX = "outbound-faxes/";

export const PARTNER_LOGOS_GCS_PREFIX = "partner-logos/";

export function gcsPathVariants(path: string): [string, string] {
  const pathWithoutSlash = path.replace(/^\/+/, "");

  return [pathWithoutSlash, `/${pathWithoutSlash}`];
}

function escapePostgrestValue(value: string): string {
  return `"${value.replace(/"/g, '""')}"`;
}

export function buildPathEqOrFilter(column: string, variants: readonly [string, string]): string {
  return variants.map((variant) => `${column}.eq.${escapePostgrestValue(variant)}`).join(",");
}

export function buildMultiColumnPathEqOrFilter(columns: string[], variants: readonly [string, string]): string {
  return columns
    .flatMap((column) => variants.map((variant) => `${column}.eq.${escapePostgrestValue(variant)}`))
    .join(",");
}

export function buildOutboundFaxGcsPath(taskId: string, filename: string): string {
  return `${OUTBOUND_FAX_GCS_PREFIX}${taskId}/${filename}`;
}

export function buildOutboundFaxFilename(taskId: string): string {
  return `${taskId}_outbound_fax.pdf`;
}

/** Immutable prepared packet, kept separately from the sender's compressed submission artifact. */
export function buildReplyFaxGcsPath(taskId: string, pdfHash: string): string {
  return buildOutboundFaxGcsPath(taskId, `${taskId}_reply_fax_${pdfHash}.pdf`);
}

export function parseOutboundFaxTaskId(pathWithoutSlash: string): string | null {
  if (!pathWithoutSlash.startsWith(OUTBOUND_FAX_GCS_PREFIX)) {
    return null;
  }

  const remainder = pathWithoutSlash.slice(OUTBOUND_FAX_GCS_PREFIX.length);
  const slashIndex = remainder.indexOf("/");

  if (slashIndex <= 0) {
    return null;
  }

  return remainder.slice(0, slashIndex);
}

export function parseOutboundFaxPath(pathWithoutSlash: string): { taskId: string; filename: string } | null {
  const taskId = parseOutboundFaxTaskId(pathWithoutSlash);

  if (!taskId) {
    return null;
  }

  const filename = pathWithoutSlash.slice(`${OUTBOUND_FAX_GCS_PREFIX}${taskId}/`.length);

  if (!filename || filename.includes("/")) {
    return null;
  }

  return { taskId, filename };
}

export function isAuthorizedOutboundFaxPath(pathWithoutSlash: string): boolean {
  const parsed = parseOutboundFaxPath(pathWithoutSlash);

  if (!parsed) return false;
  if (parsed.filename === buildOutboundFaxFilename(parsed.taskId)) return true;
  const prefix = `${parsed.taskId}_reply_fax_`;

  return parsed.filename.startsWith(prefix) && /^[a-f0-9]{64}\.pdf$/.test(parsed.filename.slice(prefix.length));
}
